<style lang="scss">
.outer-entwicklungsplan {
  background:$c-white;
  padding:15px;
  margin-bottom:20px;
  p {
    background:$c-off-white;
    padding:10px;
    margin-bottom:0;
  }
}
</style>

<template>
  <div class="outer-entwicklungsplan">
  <h3>Entwicklungsplan</h3>
  <p v-if="notiz == ''">- Es wurde noch kein Entwicklungsplan hinterlegt -</p>
  <p><pre>{{ notiz }}</pre></p>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from 'vue';
import { useStore } from 'vuex';

export default defineComponent({
  props: { unit: { type: Number, required: true } },
  setup(props) {
    const store = useStore();
    const notiz = ref('');

    onMounted(() => {
      store.dispatch('fetchNotiz', props.unit).then((res) => {
        if (res && res != null) {
          notiz.value = res;
        }
      });
    });

    return {
      notiz,
    };
  },
});
</script>
